import { ReactNode } from 'react';
import { Link } from 'react-router-dom';
import { Lock } from 'lucide-react';
import { usePlanFeature } from '@api/hooks/useSubscription';
import Button from '@components/common/Button';

interface FeatureGateProps {
  feature: string;
  children: ReactNode;
  upgradeMessage?: string;
}

export function FeatureGate({ feature, children, upgradeMessage }: FeatureGateProps) {
  const enabled = usePlanFeature(feature);
  if (enabled) return <>{children}</>;
  return <FeatureLockedPage feature={feature} message={upgradeMessage} />;
}

function FeatureLockedPage({ feature, message }: { feature: string; message?: string }) {
  return (
    <div className="max-w-xl mx-auto mt-16 p-6 text-center">
      <div className="mx-auto w-12 h-12 rounded-full bg-amber-50 border border-amber-200 flex items-center justify-center mb-4">
        <Lock className="h-5 w-5 text-amber-700" />
      </div>
      <h1 className="text-2xl font-medium text-content-primary">This feature isn't in your plan</h1>
      <p className="text-sm text-content-secondary mt-2">
        {message ?? `The "${feature}" feature requires an upgrade. Manage your subscription to add it.`}
      </p>
      <Link to="/admin/settings?tab=billing">
        <Button className="mt-6">Go to Billing</Button>
      </Link>
    </div>
  );
}
